// Typography configuration - maps type codes to Tailwind classes

// Font weight Tailwind classes
export const fontWeightClasses: Record<string, string> = {
  R: 'font-normal',   // 400
  M: 'font-medium',   // 500
  S: 'font-semibold', // 600
  B: 'font-bold',     // 700
};

// Font size Tailwind classes
export const fontSizeClasses: Record<string, string> = {
  '8': 'text-[8px]',
  '10': 'text-[10px]',
  '12': 'text-xs',      // 12px
  '14': 'text-sm',      // 14px
  '16': 'text-base',    // 16px
  '18': 'text-lg',      // 18px
  '20': 'text-xl',      // 20px
  '22': 'text-[22px]',
  '24': 'text-2xl',     // 24px
  '26': 'text-[26px]',
  '28': 'text-[28px]',
  '30': 'text-3xl',     // 30px
  '32': 'text-[32px]',
  '34': 'text-[34px]',
  '35': 'text-[35px]',
  '36': 'text-4xl',     // 36px
  '40': 'text-[40px]',
  '46': 'text-[46px]',
  '66': 'text-[66px]',
};

// Get Tailwind class for a type code like "B24" or "r14"
export const getTextClasses = (type: string): string => {
  const weightChar = type.charAt(0).toUpperCase();
  const sizeNum = type.slice(1);

  const weightClass = fontWeightClasses[weightChar] || 'font-normal';
  const sizeClass = fontSizeClasses[sizeNum] || 'text-sm';

  return `${weightClass} ${sizeClass}`;
};

// Legacy exports for backwards compatibility
export const fontWeights = {
  Regular: { fontWeight: 400 },
  Medium: { fontWeight: 500 },
  SemiBold: { fontWeight: 600 },
  Bold: { fontWeight: 700 },
};

export const fontSizes = {
  f8: { fontSize: '8px' },
  f10: { fontSize: '10px' },
  f12: { fontSize: '12px' },
  f14: { fontSize: '14px' },
  f16: { fontSize: '16px' },
  f18: { fontSize: '18px' },
  f20: { fontSize: '20px' },
  f22: { fontSize: '22px' },
  f24: { fontSize: '24px' },
  f26: { fontSize: '26px' },
  f28: { fontSize: '28px' },
  f30: { fontSize: '30px' },
  f32: { fontSize: '32px' },
  f34: { fontSize: '34px' },
  f35: { fontSize: '35px' },
  f36: { fontSize: '36px' },
  f40: { fontSize: '40px' },
  f46: { fontSize: '46px' },
  f66: { fontSize: '66px' },
};

const typography = { fontWeights, fontSizes, fontWeightClasses, fontSizeClasses, getTextClasses };

export default typography;
